import _baseGetTag_default from "./_baseGetTag.js";
import isObjectLike_default from "./isObjectLike.js";

//#region ../../node_modules/lodash-es/_baseIsArguments.js
/** `Object#toString` result references. */
var argsTag = "[object Arguments]";
/**
* The base implementation of `_.isArguments`.
*
* @private
* @param {*} value The value to check.
* @returns {boolean} Returns `true` if `value` is an `arguments` object,
*/
function baseIsArguments(value) {
	return isObjectLike_default(value) && _baseGetTag_default(value) == argsTag;
}
var _baseIsArguments_default = baseIsArguments;

//#endregion
export { _baseIsArguments_default as default };
//# sourceMappingURL=_baseIsArguments.js.map